import React from 'react'

function Input(props) {
    const { error } = props.method.getFieldState(props.methodName)
    return (
        <div className={` ${props.className} flex flex-col w-full relative`}>
            <label className='font-light text-gray-600'>{props.label}</label>
            <div className='flex'>
                <input {...props.method.register(props.methodName)} type={props.type} className={`py-[7px] px-2 outline-none border mt-1 w-full ${props.method.formState.errors[props.methodName] ? "border-red-600" : "border-[#624d4d] hover:border-gray-400"}`} readOnly={props.read}/>
                {props.icon}
            </div>
            {error && <p className='text-red-600 mt-1 mx-1'>{error.message}</p>}
        </div>
    )
}

export default Input